import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { Alert, Divider, Stack } from "@mui/material";
import { Add } from "@mui/icons-material";
import ListView from "../base/list";
import Mapping from "../mapping/mapping";
import moment from "moment";
import CONSTANT from "../../../Constant/Constant";
import { useState } from "react";
import InputDetail from "./detail-input-update";
import filter from "../../../service/filter";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const SpecialtyPopup = (props) => {
  const [editedValue] = useState([]);
  const [editValueFlag] = useState([]);
  const [label] = useState(props.label);
  const [deleteSpecialities, setDeleteSpecialities] = useState([]);
  const [addnewIdArray] = useState([]);
  const [newValue] = useState(Mapping[label + "_Open_Data"]);
  const [showSpeciality, setShowSpeciality] = useState(false);
  const [newNested, setNewNested] = useState([]);
  const [replacementSpecialtyValue, setReplacementSpecialtyValue] = useState([]);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [allSpecialty, setAllSpecialty] = useState(
    props.value && props.value?.map((item) => {
      return item.Specialty ? `${item.Specialty[0].value} | ${item.Specialty[0].lookupCode} | ${item.Specialty[0].lookupRawValue}` : "";
    }))
  const [strikeThrough, setStrikeThrough] = useState([]);

  const handleClose = () => {
    saveAllOperations();
    // props.openSpecialtyModal(false)
    // setError(false);
    // setNewNested([])
    // setDeleteSpecialities([])
    // setShowSpeciality(false);
    // for (let i = 0; i < props.value.length; i++) {
    //   const item = props.value[i];
    //   props.editValue([item], false, "Specialities", i); // now you have index
    // }
    // props.updateValue([])
    // setAllSpecialty([]);
    // setStrikeThrough([]);
  };

  /**
   * Pass value to parent
   * @param {*} newValue
   * @param {*} flag
   */
  const addNewAttribute = (newValue, flag) => {
    props.updateValue(newValue, flag);
  };

  const checkAllAddressAttribute = (arrayValue) => {
    let flag = false;
    if (arrayValue.length === 0) {
      return flag;
    } else {
      arrayValue.forEach((value) => {
        flag = flag || value.flag;
      });
      return flag;
    }
  };

  /**
   * Handle Add operation
   * @param {*} attribute
   */
  const addNewNested = (attribute) => {
    let length = "XADcZS" + attribute + addnewIdArray.length;
    addnewIdArray.push(length);
    setShowSpeciality(true);
    addNewAttribute(
      {
        OtherSpecialty: [{ value: "" }],
      },
      false
    );
  };

  const saveAllOperations = () => {

  //validation for deleted primary specialty then replacement specialty is mandatory 

  if(deleteSpecialities.length > 0 && isPrimarySpecialtyDeleted() && replacementSpecialtyValue.filter(a => a)?.length === 0) {
    setError(true)  
    setMessage("Please select replacement for deleted specialty");
    return;
  } else if(deleteSpecialities.length > 0 && isPrimarySpecialtyDeleted() && replacementSpecialtyValue.filter(a => a)?.length > 0 && !replacementSpecialtyValue.find(item => item.Rank && item.Rank[0] && item.Rank[0].value == "1")) {
    setError(true)  
    setMessage("Please select Primary Specialty for replacement of deleted Primary Specialty");
    return;
  } else{
    if(deleteSpecialities.length > 0){
       for (const item of deleteSpecialities) {
        props.editValue([item], false, "Specialities", item.id);
      }   
    }
    if(replacementSpecialtyValue.length > 0){
       for (const item of replacementSpecialtyValue) {
        props.editValue([item], false, "Specialities", item.id);
      }
    }
    if(newNested && newNested.OtherSpecialty && newNested.OtherSpecialty[0].value) {
      props.updateValue({
        ...newNested,    
        EffectiveStartDate: [
          { value: moment.utc(new Date()).format("YYYY-MM-DD") },
        ],
        EffectiveEndDate: [{ value: "9999-12-31" }],
        IsNew: true,
      })
    }
    setError(false)
  }
  //   if(deleteSpecialities.length > 0 && isPrimarySpecialtyDeleted() && replacementSpecialtyValue.filter(a => a)?.length === 0) {
  //     setError(true)  
  //     setMessage("Please select replacement for deleted specialty");
  //     return;
      
  //   }else if(deleteSpecialities.length == 0 && replacementSpecialtyValue.filter(a => a)?.length == 0 && newNested.length == 0 ){
  //     setError(true)
  //     setMessage("Please add some changes");
  //     return ;
  //   }
  //   else if(deleteSpecialities.length > 0 && !isPrimarySpecialtyDeleted()) {
  //     for (const item of deleteSpecialities.filter(val => val?.Rank[0]?.value != "1")) {
  //       props.editValue([item], false, "Specialities", item.id);
  //     }    
  //   }
  //   if(replacementSpecialtyValue.filter(a => a)?.length > 0 && isPrimarySpecialtyDeleted()) {
  //     for (const item of replacementSpecialtyValue.filter(a => a)) {
  //       props.editValue([item], false, "Specialities", item.id);
  //     }
  //     for (const item of deleteSpecialities) {
  //       props.editValue([item], false, "Specialities", item.id);
  //     } 
  //     setError(false);    
  // }

  // if(newNested && newNested.OtherSpecialty && newNested.OtherSpecialty[0].value) {
  //   props.updateValue({
  //     ...newNested,    
  //     EffectiveStartDate: [
  //       { value: moment.utc(new Date()).format("YYYY-MM-DD") },
  //     ],
  //     EffectiveEndDate: [{ value: "9999-12-31" }],
  //     IsNew: true,
  //   });
  //   setError(false);
    
  // }
    props.openSpecialtyModal(true)
  }


  /**
   * Update the DCR for Nested Value
   * @param {*} newValue
   * @param {*} index
   * @param {*} flag
   */
  const updateValue = (newValue, index, flag, Name) => {
    if (editedValue.length === 0) {
      editedValue.push({ ...newValue, editKey: "id" + index });
      editValueFlag.push({ flag, editKey: "id" + index });
    } else {
      let dummyEditValue = JSON.parse(JSON.stringify(editedValue));
      let editKey = dummyEditValue.map((i) => i.editKey).indexOf("id" + index);
      let dummyEditValueFlag = JSON.parse(JSON.stringify(editValueFlag));
      let editFlagKey = dummyEditValueFlag
        .map((i) => i.editKey)
        .indexOf("id" + index);
      //inseting item updated
      if (editKey !== -1) {
        editedValue.splice(editKey, 1, { ...newValue, editKey: "id" + index });
      } else {
        editedValue.push({ ...newValue, editKey: "id" + index });
      }
      //respective flag error checking
      if (editFlagKey !== -1) {
        editValueFlag.splice(editKey, 1, { flag, editKey: "id" + index });
      } else {
        editValueFlag.push({ flag, editKey: "id" + index });
      }
    }
    props.editValue(
      editedValue,
      checkAllAddressAttribute(editValueFlag),
      Name,
      index
    );
  };

  const deleteSepcialty = (index, element) => {
    let updatedSpecialty = props.value.find((item, idx) => item.uri === element.uri);
    updatedSpecialty["isDeleted"] = true;
    props.editValue([updatedSpecialty], false, "Specialities", index);
    setDeleteSpecialities([...deleteSpecialities, { ...element, isDeleted: true, id: index }]);
    setStrikeThrough([...strikeThrough, element.uri ]);

    // let updatedSpecialty = JSON.parse(JSON.stringify(props.value[index]));
    // updatedSpecialty["isDeleted"] = true;
    // deleteSpecialities.push({ ...element, isDeleted: true, id: index });
    // //props.editValue([updatedSpecialty], false, "Specialities", index);
    // setStrikeThrough({...strikeThrough, [index]: true });
  };

  const undoDeleteSepcialty = (index, spclty) => {
    let updatedSpecialty = props.value.find((item, idx) => item.uri === spclty.uri);
    delete updatedSpecialty.isDeleted;
    if(updatedSpecialty['Replacement'])
      delete updatedSpecialty.Replacement;
    props.editValue([updatedSpecialty], false, "Specialities", index);
    setDeleteSpecialities(
      deleteSpecialities.filter((item) => {
        return item.uri !== spclty.uri;
      })      
    );
    setReplacementSpecialtyValue(
      replacementSpecialtyValue.filter((item) => { return item.uri !== spclty.uri; })
    )
    setStrikeThrough(strikeThrough.filter(item => item !== spclty.uri));

    // let updatedSpecialty = props.value.find((item, idx) => item.uri === spclty.uri);
    // // updatedSpecialty["isDeleted"] = false;
    // delete updatedSpecialty.isDeleted;
    // if(updatedSpecialty['Replacement'])
    //   delete updatedSpecialty.Replacement;
    // props.editValue([updatedSpecialty], false, "Specialities", index);
    // setDeleteSpecialities(
    //   deleteSpecialities.filter((item) => {
    //     return item.id !== index;
    //   })      
    // );
    // setReplacementSpecialtyValue(
    //   replacementSpecialtyValue.filter((item) => { return item.id !== index; })
    // )
    // setStrikeThrough({...strikeThrough, [index]: false });
  };

  /**
   * Handel Nested attribute Changes
   * @param {*} newValue
   * @param {*} newName
   * @param {*} flag
   */
  const setNewNestedValue = async (newValue, newName, flag) => {
    if(newNested && newName == 'OtherSpecialty' && newValue?.value?.length == 0){
      setAllSpecialty([...allSpecialty.filter(item => item !== (newNested && newNested['OtherSpecialty'] ? newNested['OtherSpecialty'][0].value[0] : ""))])
    }
    else {
      setAllSpecialty([...allSpecialty, ...newValue.value]);  
    }
    await setNewNested({
      ...newNested,
      [newName]: [newValue],
    });
  };

  const setReplacementValue = (newValue, index, name, element) => {

    let prevValue = replacementSpecialtyValue.find((item, idx) => item.uri === element.uri);
    let prevarray = [...allSpecialty]

    if(prevValue && prevValue['Replacement'] && prevValue['Replacement'][name]) {
      prevarray = prevarray.filter(item => item !== prevValue['Replacement'][name][0].value)
    }

   if(newValue && newValue.value && newValue.value.length > 0){
     let updatedValue = JSON.parse(JSON.stringify(deleteSpecialities.find((item, idx) => item.uri === element.uri)));
      updatedValue = {
        ...updatedValue,
        isDeleted: true,
        Replacement: {
          [name]: [newValue],
          EffectiveStartDate: [
          { value: moment.utc(new Date()).format("YYYY-MM-DD") },
        ],
        EffectiveEndDate: [{ value: "9999-12-31" }],
        IsNew: true
        }
      }

      let replacementArray = JSON.parse(JSON.stringify(replacementSpecialtyValue));
      let replaceKey = replacementArray
          .map((i) => i.uri)
          .indexOf(element.uri);
      if (replaceKey !== -1) {
        replacementArray.splice(replaceKey, 1, updatedValue);
      } else {
        replacementArray.push(updatedValue);
      }
      setDeleteSpecialities(
        deleteSpecialities.map(item => item.uri === element.uri ? updatedValue : item)
      )
      setReplacementSpecialtyValue(replacementArray);        
      setAllSpecialty([...prevarray, Array.isArray(newValue.value) ? newValue.value[0] : newValue.value]);
    } else {
      // if user remove the selected value from dropdown remove from replacement array and also from deleteSpecialty array and allSpecialty array
      let removeReplacement = replacementSpecialtyValue.find(val => val.uri == element.uri)
      if(removeReplacement){
        let removeReplacementValue = removeReplacement['Replacement'][name][0].value[0]
        let updatedAllSpecialty = allSpecialty.filter(val => val !== removeReplacementValue)
        let updatedValue = JSON.parse(JSON.stringify(deleteSpecialities.find((item, idx) => item.uri === element.uri)));
        delete updatedValue['Replacement']
        
        let replacementArray = JSON.parse(JSON.stringify(replacementSpecialtyValue));
        let replaceKey = replacementArray
        .map((i) => i.uri)
        .indexOf(element.uri);
        if (replaceKey !== -1) {
          replacementArray.splice(replaceKey, 1);
        } 
        
        
        setDeleteSpecialities(
          deleteSpecialities.map(item => item.uri === element.uri ? updatedValue : item)
        )
        setReplacementSpecialtyValue(replacementArray);        
        setAllSpecialty(updatedAllSpecialty)
      }
   }
   
    

    // let previousValue = replacementSpecialtyValue[index];
    // let prevarray = [...allSpecialty]

    // if(previousValue && previousValue['Replacement'] && previousValue['Replacement'][name]) {
    //   prevarray = prevarray.filter(item => item !== previousValue['Replacement'][name][0].value)
    // }
    // let updatedValue = JSON.parse(JSON.stringify(deleteSpecialities[index]));
    // updatedValue = {
    //   ...updatedValue,
    //   isDeleted: true,
    //   Replacement: {
    //     [name]: [newValue],
    //     EffectiveStartDate: [
    //     { value: moment.utc(new Date()).format("YYYY-MM-DD") },
    //   ],
    //   EffectiveEndDate: [{ value: "9999-12-31" }],
    //   IsNew: true,
    //   }
    // }
    // deleteSpecialities[index] = updatedValue;
    // replacementSpecialtyValue[index] = updatedValue;        
    // setAllSpecialty([...prevarray, Array.isArray(newValue.value) ? newValue.value[0] : newValue.value]);
    // //props.editValue([updatedValue], false, "Specialities", updatedValue.id);
  };

  const isPrimarySpecialtyDeleted = () => {
    let isRankOneSpecialtyDeleted = false;
    deleteSpecialities.forEach((item)=>{
      if(item.Rank && item.Rank[0] && item.Rank[0].value == "1"){
        isRankOneSpecialtyDeleted = true;
      }
    });
    return isRankOneSpecialtyDeleted ;
  }

  return (
    <React.Fragment>

      <BootstrapDialog
        fullWidth
        maxWidth="md"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Add / Delete Specialty
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ maxHeight: "50vh", overflowY: "scroll" }}>
          {error &&
           <Alert className="pt-0 pb-0 mt-0" variant="filled" severity="error"> {message}</Alert>}
          <div className="row col-md-12 mt-2">           
            <Typography className="_wg-dynamic-text" variant="subtitle1">
              <b>Specialities:</b>
            </Typography>
            {props.value && props.value?.sort((a, b) => {
                  const rankA = a?.Rank?.[0]?.value ?? 99; // Use 99  if Rank is missing
                  const rankB = b?.Rank?.[0]?.value ?? 99;
                  return rankA - rankB;
                })?.map((element, i) => {
              return (
                <div className="col-md-6" key={i}>
                  <ListView
                    updateValue={(newValue, flag) =>
                      updateValue(newValue, i, flag, props.label)
                    }
                    key={i}
                    label={
                      element.Specialty
                        ? element.Specialty[0].value
                        : "<No Label>"
                    }
                    value={element}
                    fieldName={props.label}
                    entity={props.entity}
                    editSpecialty={props.mode}
                    deleteSepcialty={() => deleteSepcialty(i, element)}
                    undoDeleteSepcialty={() => undoDeleteSepcialty(i, element)}
                    source={props.source ? props.source[0].value : null}
                    strikeThrough={strikeThrough.includes(element.uri)}
                  />
                </div>
              );
            })}
          </div>
          <Divider className="mt-3 mb-3" />
          {deleteSpecialities.length > 0 && (
            <>
              <Typography className="_wg-dynamic-text mb-2" variant="subtitle1">
                <b>Deleted Specialty Replacement:</b>
              </Typography>

              {deleteSpecialities.sort((a,b) => a?.Rank[0]?.value - b?.Rank[0]?.value)?.map((element, i) => {
                return (
                  <div
                    className="row col-md-12"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                    }}
                    key={element.uri}
                  >
                    <div className="col-md-4">
                      <Typography align="left" variant="subtitle1">
                        {element.Specialty[0].value}
                      </Typography>
                    </div>
                    <div className="col-md-6">
                      <span className="text-muted">
                        {element.Rank[0].value == "1"
                          ? "Primary Specialty *"
                          : "Other Specialty"
                        }
                      </span>
                      <InputDetail
                        vendor={props.vendor}
                        error={props.error}
                        type={"select"}
                        date={false}
                        label={
                          element.Rank[0].value == "1"
                            ? "Primary Specialty"
                            : "Other Specialty"
                        }
                        value={

                          element['Replacement'] && element['Replacement'][element.Rank[0].value == "1" ? "PrimarySpecialty" : "OtherSpecialty"] ? 
                            element['Replacement'][element.Rank[0].value == "1" ? "PrimarySpecialty" : "OtherSpecialty"][0]?.value :
                            ""
                          // deleteSpecialities[i]['Replacement'] && deleteSpecialities[i]['Replacement'][element.Rank[0].value == "1"
                          // ? "PrimarySpecialty"
                          // : "OtherSpecialty"] ? deleteSpecialities[i]['Replacement'][element.Rank[0].value == "1"
                          // ? "PrimarySpecialty"
                          // : "OtherSpecialty"][0].value  :""
                        }
                        newValue={newValue}
                        filteredValue={true}
                        count = {1}
                        allSpecialty={allSpecialty}
                        limitFlag = {element.Rank[0].value == "1" ? false : true}
                        updatedValue={(newValue, flag) => {
                          setReplacementValue(
                            newValue,
                            i,
                            element.Rank[0].value == "1"
                              ? "PrimarySpecialty"
                              : "OtherSpecialty",
                            element
                          );
                        }}
                        entity={props.entity}
                      />
                    </div>
                  </div>
                );
              })}
              <Divider className="mt-3 mb-3" />
            </>
          )}

          {!showSpeciality && (
            <Stack direction="row" alignItems="center">
              <IconButton
                size="small"
                sx={{
                  backgroundColor: "var(--lilly-primary)",
                  "&:hover": {
                    background: "var(--lilly-primary)",
                    opacity: "0.6",
                  },
                }}
                onClick={() => addNewNested(label)}
              >
                <Add sx={{ color: "white" }} />
              </IconButton>
              <Typography
                marginLeft="10px"
                className="_wg-dynamic-text"
                variant="subtitle1"
                onClick={() => addNewNested()}
              >
                Add New Other Specialty
              </Typography>
            </Stack>
          )}
          <div className="row col-md-12 mt-2">
            {props.mode == "Edit" &&
              showSpeciality &&
              Object.keys(newValue).map((labels, i) => {
                let keysValue = labels;
                let propertyValue = newValue[labels];
                if (labels.length > 3) {
                  labels = labels
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase());
                }
                labels = filter.getLabelName(
                  labels !== undefined ? labels.trim() : labels
                );
                return (
                  <div className="col-md-8" key={i}>
                    <Typography className="_wg-dynamic-text mb-2" variant="subtitle1"><b>Add New Other Speciality:</b></Typography>
                    
                    <span className="text-muted mb-2  mt-2">
                      {labels +
                        (CONSTANT.REQUIRED_HCP.includes(labels) ? " *" : "") +
                        ":" || ""}
                    </span>
                    <InputDetail
                      vendor={props.vendor}
                      error={props.error}
                      type={propertyValue}
                      date={propertyValue === "date"}
                      label={labels}
                      value={newNested && newNested['OtherSpecialty'] != undefined ? newNested['OtherSpecialty'][0].value : ""}
                      newValue={newValue}
                      updatedValue={(newValue, flag) => {
                        setNewNestedValue(newValue, keysValue, flag);
                      }}
                      entity={props.entity}
                      count = {props.count}
                      limitFlag = {true}
                      allSpecialty={allSpecialty}
                      filteredValue={true}
                    />
                  </div>
                );
              })}
           
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            color="error"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={saveAllOperations}
            color="error"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default SpecialtyPopup;
